import Banner from "../components/urban/banner";
import Navbar from "../components/urban/navbar";
import Section from "../components/urban/section";
import {
  servicesData,
  projectsData,
  livingFurnitureData,
  projects,
  clientLogos,
  galleryTitles,
} from "../components/urban/mock";
import AboutSection from "../components/urban/about-section";
import Footer from "../components/urban/footer";
// import SliderSection from "../components/urban/slider-section";
// import { officeFurnitureData } from "../components/urban/mock";
import WorkingProcess from "../components/urban/working-process";
import AppRoutes from "../routes";
import Projects from "../components/urban/projects";
import OurClients from "../components/urban/clinets";
import { useEffect, useState } from "react";
import { fetchImagUrls } from "../firebase/utlis";
import { useParams } from "react-router-dom";
import Container from "../components/urban/container";
import Logo from "../assets/images/urban/favicon.png";
// import ImageGallery from "react-image-gallery";
import ReactImageGallery from "react-image-gallery";
const HomePage = () => {
  useEffect(() => {
    const favicon = document.getElementById("favicon");
    if (favicon) favicon.href = Logo;
  }, []);
  return (
    <>
      <Banner />
      <div className="space-y-10 md:space-y-14 py-10 md:py-14">
        <AboutSection />
        <Section {...servicesData} />
        {/* <SliderSection  data={officeFurnitureData}/>
        <SliderSection  data={livingFurnitureData}/> */}
        <OurClients images={clientLogos} />
        <Section {...projectsData} />
        <WorkingProcess />
      </div>
    </>
  );
};
const ProjectOne = () => {
  return (
    <div>
      <Projects data={projects[0]}></Projects>
    </div>
  );
};
const ProjectTwo = () => {
  return <Projects data={projects[1]}></Projects>;
};
const ProjectThree = () => {
  return <Projects data={projects[2]}></Projects>;
};
const ProjectFour = () => {
  return <Projects data={projects[3]}></Projects>;
};
const Loading = () => {
  return (
    <div className="w-full min-h-[20vh] flex items-center justify-center">
      <div role="status">
        <svg
          aria-hidden="true"
          class="w-8 h-8 text-gray-200 animate-spin dark:text-gray-600 fill-blue-600"
          viewBox="0 0 100 101"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M100 50.5908C100 78.2051 77.6142 100.591 50 100.591C22.3858 100.591 0 78.2051 0 50.5908C0 22.9766 22.3858 0.59082 50 0.59082C77.6142 0.59082 100 22.9766 100 50.5908ZM9.08144 50.5908C9.08144 73.1895 27.4013 91.5094 50 91.5094C72.5987 91.5094 90.9186 73.1895 90.9186 50.5908C90.9186 27.9921 72.5987 9.67226 50 9.67226C27.4013 9.67226 9.08144 27.9921 9.08144 50.5908Z"
            fill="currentColor"
          />
          <path
            d="M93.9676 39.0409C96.393 38.4038 97.8624 35.9116 97.0079 33.5539C95.2932 28.8227 92.871 24.3692 89.8167 20.348C85.8452 15.1192 80.8826 10.7238 75.2124 7.41289C69.5422 4.10194 63.2754 1.94025 56.7698 1.05124C51.7666 0.367541 46.6976 0.446843 41.7345 1.27873C39.2613 1.69328 37.813 4.19778 38.4501 6.62326C39.0873 9.04874 41.5694 10.4717 44.0505 10.1071C47.8511 9.54855 51.7191 9.52689 55.5402 10.0491C60.8642 10.7766 65.9928 12.5457 70.6331 15.2552C75.2735 17.9648 79.3347 21.5619 82.5849 25.841C84.9175 28.9121 86.7997 32.2913 88.1811 35.8758C89.083 38.2158 91.5421 39.6781 93.9676 39.0409Z"
            fill="currentFill"
          />
        </svg>
        <span class="sr-only">Loading...</span>
      </div>
    </div>
  );
};
const Project = () => {
  const [urls, setUrls] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const { keyword } = useParams();
  useEffect(() => {
    setIsLoading(true);
    fetchImagUrls(`urban/${keyword}`)
      .then((res) => {
        setUrls(res);
        console.log("responses ", res);
      })
      .catch((e) => {
        console.log("Error fetching images", e);
      })
      .finally(() => {
        setIsLoading(false);
      });
  }, [keyword]);

  const galleryItems = urls?.map((url) => {
    return {
      original: url,
      thumbnail: url,
    };
  });
  return (
    <div>
      <Container className={"px-5 py-5 space-y-5 "}>
        <p className="text-xl md:text-2xl font-bold">
          {galleryTitles[keyword] || "Gallery"}
        </p>
        <div className="w-full mx-auto">
          {isLoading && <Loading />}
          {/* {urls?.map((url, idx) => {
            return (
              <div key={idx} className="aspect-video md:aspect-square">
                <img
                  src={url}
                  alt="Urban"
                  className="w-full h-full object-cover"
                />
              </div>
            );
          })} */}
          {galleryItems.length > 0 && (
            <ReactImageGallery items={galleryItems} />
          )}
        </div>
      </Container>
    </div>
  );
};
const UrbanTemplate = () => {
  return (
    <div className="font-inter overflow-hidden">
      <Navbar />
      <AppRoutes
        homePage={HomePage}
        ProjectOne={ProjectOne}
        ProjectTwo={ProjectTwo}
        ProjectThree={ProjectThree}
        ProjectFour={ProjectFour}
        Project={Project}
      />
      <Footer />
    </div>
  );
};

export default UrbanTemplate;
